import { getItem, setItem, removeItem } from "../utils/safeStorage";

/*
 * Tokens go through safeStorage rather than `localStorage` directly: iOS Safari
 * throws on storage access when the visitor blocks cookies, and this module is
 * on the landing page's import path via RootGate. A read that fails there must
 * mean "not signed in", never "blank page".
 */

const getLocalRefreshToken = () => {
  const refreshToken = getItem("refreshTkn");
  return refreshToken;
};

const getLocalAccessToken = () => {
  const accessToken = getItem("accessTkn");
  return accessToken;
};

const updateLocalAccessToken = (token) => {
  setItem("accessTkn", token);
};

const updateLocalRefreshToken = (token) => {
  setItem("refreshTkn", token);
};

const removeTokens = () => {
  removeItem("refreshTkn");
  removeItem("accessTkn");
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  updateLocalRefreshToken,
  removeTokens,
};

export default TokenService;
